export const DAILY_GOAL = 'Daily goal';
export const DAILY_GOAL_TEXT = 'Don’t lose your&nbsp;progress:';
